'use strict';

const isDesktopOrTabletLandscapeView = () => {
    const deviceMinWidth = 1024;
    const vpWidth = $(window).width();

    return vpWidth >= deviceMinWidth;
};

module.exports = isDesktopOrTabletLandscapeView;
